<template>
  <div id="app">
    <!-- 一级路由 -->
	
	<transition :name="SkipSwitchName">	
		<router-view>
		</router-view>
	</transition>

  </div>
</template>
<script>
	export default{
		 data(){
			 return{
				  SkipSwitchName: "",
			 }
		 }
	}
</script>


<style lang="less">
  body{
    background-color: #f4f4f4;
	height: 100%;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .fl{
    float: left;
  }

  .fr{
    float: right;
  }

  .clearfix::after{
    content: "";
    display: block;
    clear: both;
  }

  .auto-img{
    width: 100%;
	display: block;
  }
  
  .item-center{
	  text-align: center !important;
  }
  
  .one-text{
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
  }
  
  .pro-name{
	  font-size: 16px;
	  font-weight: bold;
  }
  
  .Skright-enter-active,
  .Skright-leave-active,
  .Skleft-enter-active,
  .Sklef-leave-active {
    transition: all 600ms;
  }
  //先给 所要用的上下层级跳转写一个过渡时间
  //然后你就可以发挥自己的想象力来写自己动画了 下面是一个例子
  .Skright-enter {
    transform: translate3d(-100%, 0, 0);
  }
  .Skright-leave-to {
    transform: translate3d(100%, 0, 0);
  }
  .Skleft-enter {
    transform: translate3d(100%, 0, 0);
  }
  .Skleft-leave-to {
    transform: translate3d(-100%, 0, 0);
  }
  
</style>
